{
  "tricks": {
    "spin360":  { "value": 250 },
    "backflip": { "value": 500 },
    "superman": { "value": 300 },
    "noHander": { "value": 200 }
  },
  "trickDuration": 0.6,
  "spin180Value": 125,
  "cleanLandingAngle": 45,
  "air": {
    "gravity": 20,
    "launchPerSpeed": 0.3,
    "bunnyhopVz": 10,
    "bunnyhopCooldownS": 0.5,
    "popWindowS": 0.15,
    "popBonus": 0.3,
    "airTurnFactor": 0.3,
    "dropVzFactor": 0.4,
    "spinDegPerS": 540,
    "bigAirS": 0.6,
    "cleanLandSpeedBonus": 1,
    "tableShortLoss": 0.3,
    "mudLandLoss": 0.2
  }
}
